import { Pricing } from '@/models/pricings/pricing';
import { axiosService } from '.';

export default class PricingsService {
    public async getPricings(projectIds: number[]): Promise<Pricing[]> {
        const projectIdsQueryString = 'projectIds=' + projectIds.join('&projectIds=');
        const response = await axiosService.instance.get(`pricings/organization/by-projects?${projectIdsQueryString}`);
        return response.data.map((pricing: any) => new Pricing(pricing));
    }
}

export const pricingsService = new PricingsService();
